export default "__VITE_ASSET__CoqyLlVa__"